import { createFileRoute } from "@tanstack/react-router";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { siteConfig } from "@/config";

export const Route = createFileRoute("/about-us")({
  head: () => {
    const title = `About ${siteConfig.siteName} — Our Editorial Approach`;
    const desc = `Meet ${siteConfig.siteName}: an independent editorial team publishing honest CRM reviews, comparisons, and buyer's guides.`;
    const url = `${siteConfig.domain}/about-us`;
    return {
      meta: [
        { title },
        { name: "description", content: desc },
        { property: "og:title", content: title },
        { property: "og:description", content: desc },
        { property: "og:url", content: url },
      ],
      links: [{ rel: "canonical", href: url }],
    };
  },
  component: About,
});

function About() {
  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="mx-auto max-w-3xl px-4 py-12">
        <h1 className="text-4xl font-bold tracking-tight">About {siteConfig.siteName}</h1>
        <div className="prose-article mt-6">
          <p>
            {siteConfig.siteName} is an independent editorial project focused on
            one thing: helping revenue teams choose the right CRM. We publish
            hands-on reviews, head-to-head comparisons, and buyer's guides that
            skip the marketing language and focus on the tradeoffs that actually
            matter after month one.
          </p>
          <h2>How we test</h2>
          <p>
            Every product we cover is set up with a working pipeline, at least
            one integration, and a live pilot before we publish. We combine
            hands-on testing with interviews from operators running the tools at
            scale — sales managers, RevOps leads, and founders. If a product
            fails us in practice, we say so.
          </p>
          <h2>Editorial independence</h2>
          <p>
            We may earn a commission when readers subscribe to a tool through
            certain links. That never changes our rankings. Products earn their
            spot on the strength of the pilot — nothing else.
          </p>
          <h2>Contact</h2>
          <p>
            Have a correction, a pitch, or a product you want us to test? Email{" "}
            <a href={`mailto:${siteConfig.contactEmail}`}>
              {siteConfig.contactEmail}
            </a>
            .
          </p>
        </div>
      </main>
      <Footer />
    </div>
  );
}
